import React from 'react'
import Timeline, { TimelineItem } from '../../../../../../components/molecules/Timeline/Timeline'


export interface HistoricStatusViewProps {
    items?: TimelineItem[]
    
}
function HistoricStatusView({items} : HistoricStatusViewProps) {
  return <Timeline items={items} maxHeight={300}/>
}

export default HistoricStatusView
